import Vue from "vue";
import App from "@/App.vue";
import createRouter from "shared/routing/createRouter";
import store from "shared/store";
import requestor from "shared/service/requestor";
import alert from "shared/service/plugins/alert";
import EdeoneConfig from "@/common/config";
import "shared/service/plugins/jivosite";
import "shared/service/plugins/ecommpay";
import "shared/service/plugins/cloudpayments";

export const config = new EdeoneConfig(
  {
    production: "https://cab.edeone.com",
    preproduction: "https://cab2.edeone.com",
    localdev: "http://localhost:8001",
  },
  {
    production: "https://store.edeone.com",
    preproduction: "https://store2.edeone.com",
    localdev: "http://localhost:8005",
  },
  {
    production: "https://edeone.com",
    preproduction: "https://edeone.com",
    localdev: "http://localhost:8007",
  }
);

Vue.config.productionTip = false;

// Global 3rd party plugins
import "bootstrap";
import "popper.js";
import "tooltip.js";
import "perfect-scrollbar";

// Vue 3rd party plugins
import vuetify from "shared/service/plugins/vuetify";
import "shared/service/plugins/bootstrap-vue";
import "shared/service/plugins/perfect-scrollbar";
import "shared/service/array-prototype";
import "@mdi/font/css/materialdesignicons.css";
import routes from "./routes";
Vue.use(alert);

requestor.init();

const router = createRouter(routes);

export const vueInstance = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

Vue.config.devtools = true;
